<template>
<div class="contents">
  <admin-dispatch-reservations adminType="staff" />
</div>
</template>

<script>
import AdminDispatchReservations from './../Admin/AdminDispatchReservations.vue'

export default {
  name: 'staff-dispatch-reservations',
  components: {
    AdminDispatchReservations
  }
}
</script>
